module.exports = __webpack_public_path__ + "static/media/waves_4.c5515338.jpg";